import { createDefaultMutationHook } from "hooks/useMutationHandler";

import {
  USER_GUIDE_START,
  USER_GUIDE_MOVE_TO_NEXT_STEP,
  USER_GUIDE_COMPLETE,
  USER_GUIDE_ABANDON,
  USER_GUIDE_RESTART,
  GET_USER_GUIDE_PROGRESS,
  GET_USER_GUIDE_GROUP,
  GET_USER_GUIDE_GROUPS,
} from "./gql";

const REFETCH_QUERIES = [GET_USER_GUIDE_PROGRESS, GET_USER_GUIDE_GROUP, GET_USER_GUIDE_GROUPS];

const useStartUserGuideMutation = createDefaultMutationHook(USER_GUIDE_START);
const useMoveToNextStepMutation = createDefaultMutationHook(USER_GUIDE_MOVE_TO_NEXT_STEP);
const useCompleteUserGuideMutation = createDefaultMutationHook(USER_GUIDE_COMPLETE);
const useAbandonUserGuideMutation = createDefaultMutationHook(USER_GUIDE_ABANDON);
const useRestartUserGuideMutation = createDefaultMutationHook(USER_GUIDE_RESTART);

const useUserGuideProgressMutations = () => {
  const [startUserGuide] = useStartUserGuideMutation({ refetchQueries: REFETCH_QUERIES });
  const [moveToNextStep] = useMoveToNextStepMutation({ refetchQueries: REFETCH_QUERIES });
  const [completeUserGuide] = useCompleteUserGuideMutation({ refetchQueries: REFETCH_QUERIES });
  const [abandonUserGuide] = useAbandonUserGuideMutation({ refetchQueries: REFETCH_QUERIES });
  const [restartUserGuide] = useRestartUserGuideMutation({ refetchQueries: REFETCH_QUERIES });

  return {
    startUserGuide,
    moveToNextStep,
    completeUserGuide,
    abandonUserGuide,
    restartUserGuide,
  };
};

export default useUserGuideProgressMutations;
